import { useEffect, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import api from "@/lib/api";
import { formatEUR } from "@/lib/format";
import { useLang } from "@/i18n";
import { Reveal } from "./Reveal";
import { BeforeAfterSlider } from "./BeforeAfterSlider";

export const BeforeAfterSection = () => {
  const [ops, setOps] = useState([]);
  const { t, lang } = useLang();

  useEffect(() => {
    api.get("/operations", { params: { lang } })
      .then((r) => setOps(r.data.filter((o) => o.before_image_url && o.image_url)))
      .catch(() => {});
  }, [lang]);

  if (!ops.length) return null;

  return (
    <section id="prima-dopo" data-testid="before-after-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto border-t border-amber-500/10">
      <Reveal>
        <p className="text-xs tracking-[0.35em] uppercase font-mono text-amber-400/90 mb-4">{t("ba_overline")}</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-zinc-100 max-w-2xl">
          {t("ba_h1")} <span className="italic text-gold">{t("ba_h2")}</span>
        </h2>
        <p className="flex items-center gap-3 text-sm sm:text-base text-zinc-400 leading-relaxed mt-6 max-w-xl">
          <MoveHorizontal size={18} className="text-[#D4AF37] shrink-0" />
          {t("ba_hint")}
        </p>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mt-14">
        {ops.slice(0, 2).map((op, i) => (
          <Reveal key={op.id} delay={i * 0.15}>
            <BeforeAfterSlider before={op.before_image_url} after={op.image_url} aspect="aspect-[4/3]" />
            <div className="flex items-end justify-between mt-5">
              <div>
                <h3 className="font-display text-xl sm:text-2xl font-semibold text-zinc-100">{op.title}</h3>
                <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 mt-1.5">{op.location}</p>
              </div>
              <div className="text-right">
                <p className="font-display text-lg text-gold">{op.roi}</p>
                <p className="text-xs text-zinc-500 mt-1">{formatEUR(op.value)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
